/**
 * @fileoverview Badge Style Utility
 *
 * NOTE: This file currently hardcodes Tailwind classes.
 * Source of truth for badge colors is BADGE_REGISTRY in @loci/types.
 * Planned refactor: replace manual maps with CSS variable-driven classes
 * emitted by badge-tokens.ts (e.g. bg-[var(--badge-primary-bg)] text-[var(--badge-primary-fg)]).
 *
 * Temporary until Tailwind config exposes semantic token classes.
 */
/**
 * Map badge variant to Tailwind CSS classes using design tokens
 */
const VARIANT_CLASS_MAP = {
    primary: 'bg-violet-500 text-violet-50 border-violet-600 hover:bg-violet-600',
    secondary: 'bg-gray-500 text-gray-50 border-gray-600 hover:bg-gray-600',
    accent: 'bg-green-500 text-green-50 border-green-600 hover:bg-green-600',
    warning: 'bg-red-500 text-red-50 border-red-600 hover:bg-red-600',
    success: 'bg-emerald-500 text-emerald-50 border-emerald-600 hover:bg-emerald-600',
};
/**
 * Specialized color overrides for specific badge types
 * These provide more specific styling than the generic variants
 */
const TYPE_SPECIFIC_OVERRIDES = {
    'almost-full': 'bg-amber-500 text-amber-50 border-amber-600 hover:bg-amber-600',
    'near-you': 'bg-blue-500 text-blue-50 border-blue-600 hover:bg-blue-600',
    online: 'bg-sky-50 text-sky-700 border-sky-500 hover:bg-sky-100',
    recurring: 'bg-amber-100 text-amber-900 border-amber-500 hover:bg-amber-200',
};
/**
 * Get CSS classes for a badge based on its variant
 */
export function getVariantClasses(variant) {
    return VARIANT_CLASS_MAP[variant] || VARIANT_CLASS_MAP.secondary;
}
/**
 * Get CSS classes for a badge type, checking for specific overrides first
 */
export function getBadgeClasses(type, variant) {
    return TYPE_SPECIFIC_OVERRIDES[type] || getVariantClasses(variant);
}
